import Axios from 'axios'

export const axios = function (config: any) {
    let configCom = {
        method: config.method || 'get',
        headers: {},
        ...config,
    }
    if (!('authorization' in config) || config.authorization) {
        // 不带authorization或设为true则加入jwt
        const token = window.localStorage.getItem('token')
        const params = configCom.params || {}
        params.token = token
        configCom.params = params
        configCom.headers['Authorization'] = `${token || ''}`
    }
    return new Promise<{
        status: number
        data: any
    }>((resolve, reject) => {
        Axios(configCom)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
